import abeImage from "../assets/abePic.jpg";
import brandonImage from "../assets/0.jpg";

const PROFILES = [
    {
        id: 1,
        name: 'Abe Shukert',
        picture: abeImage,
        title: 'Principal Software Engineer',
        description: 'Abe Shukert is a highly skilled engineer with nearly \
        three decades of hardware and software experience in various \
        industries. He enjoys creating new products, troubleshooting \
        complex problems, and seeing designs through from concept into \
        production. He especially enjoys sharing his knowledge and love of \
        engineering, electronics and embedded systems with junior engineers \
        and anyone else who is interested.'
    },
    {
        id: 2,
        name: 'Brandon Bickerton',
        picture: brandonImage,
        title: 'Software Engineer',
        description: 'Brandon Bickerton is a software engineer that is highly skilled in C#, \
        Python, JavaScript and a number of programming frameworks, including Django, Entity Framework, \
        MVC, jQuery, React and others.  He has experience in a creating a broad range of software applications \
        including, desktop apps, web applications and Windows Services. '
    }
 
]


export default PROFILES;
